import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import StaffDashboard from './dashboard/StaffDashboard';
import ManagerDashboard from './dashboard/ManagerDashboard';
import AdminDashboard from './dashboard/AdminDashboard';

const DashboardPage = () => {
  const { user } = useAuth();

  // ŞİMDİLİK: Tüm kullanıcılar için StaffDashboard göster
  // TODO: Gelecekte role bazlı dashboard gösterimi için bu kısım geri alınacak
  const renderDashboardContent = () => {
    // Tüm kullanıcılar için StaffDashboard göster
    return <StaffDashboard />;
    
    // Gelecekte role bazlı gösterim için aşağıdaki kod kullanılacak:
    /*
    // Kullanıcı yoksa default olarak StaffDashboard göster
    if (!user) {
      return <StaffDashboard />;
    }

    // Role name'e göre dashboard seçimi
    const roleName = user.role_name || user.role?.role_name || '';
    
    // Role name'e göre dashboard render et
    switch (roleName.toLowerCase()) {
      case 'admin':
      case 'administrator':
        return <AdminDashboard />;
      case 'manager':
      case 'yönetici':
      case 'müdür':
        return <ManagerDashboard />;
      case 'staff':
      case 'personel':
      case 'it':
      case 'employee':
      default:
        return <StaffDashboard />;
    }
    */
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {renderDashboardContent()}
    </div>
  );
};

export default DashboardPage;